import { ContactItem } from 'reducers/contactList/contactList.types'

export const contactsWithProfile = (item: ContactItem) => item && item.anketa
